/** Quick-entry table rows and parse samples for Help panel + tests. */

/**
 * @typedef {{ id: string, token: string, meaningKey: string, exampleKey: string }} HelpQuickbarRow
 */

/** @type {HelpQuickbarRow[]} */
export const HELP_QUICKBAR_ROWS = [
  {
    id: 'project',
    token: '#',
    meaningKey: 'help.quickbar.row.project.meaning',
    exampleKey: 'help.quickbar.row.project.example',
  },
  {
    id: 'context',
    token: '@',
    meaningKey: 'help.quickbar.row.context.meaning',
    exampleKey: 'help.quickbar.row.context.example',
  },
  {
    id: 'duration',
    token: '~',
    meaningKey: 'help.quickbar.row.duration.meaning',
    exampleKey: 'help.quickbar.row.duration.example',
  },
  {
    id: 'person',
    token: '+',
    meaningKey: 'help.quickbar.row.person.meaning',
    exampleKey: 'help.quickbar.row.person.example',
  },
  {
    id: 'date',
    token: '>',
    meaningKey: 'help.quickbar.row.date.meaning',
    exampleKey: 'help.quickbar.row.date.example',
  },
  {
    id: 'recurrence',
    token: '*',
    meaningKey: 'help.quickbar.row.recurrence.meaning',
    exampleKey: 'help.quickbar.row.recurrence.example',
  },
];

/** Monospace example sentence under the quick-entry table. */
export const HELP_QUICKBAR_FULL_EXAMPLE_KEY = 'help.quickbar.example';

/**
 * Each sample must parse via `parseTaskInput` (title prefix keeps tags valid).
 * @type {Array<{ input: string, projects?: string[], contexts?: string[], duration?: number, person?: string, date?: string, recurrence?: { interval: number, frequency: string } | null }>}
 */
export const HELP_QUICKBAR_PARSE_SAMPLES = [
  { input: 'Taak #werk', projects: ['werk'] },
  { input: 'Taak @kantoor', contexts: ['kantoor'] },
  { input: 'Taak ~30m', duration: 30 },
  { input: 'Taak ~1u', duration: 60 },
  { input: 'Taak ~1h30', duration: 90 },
  { input: 'Taak +jan', person: 'jan' },
  { input: 'Taak >morgen', date: 'parsed:morgen' },
  { input: 'Taak >vrijdag', date: 'parsed:vrijdag' },
  { input: 'Taak >vandaag', date: 'parsed:vandaag' },
  { input: 'Taak *1m', recurrence: { interval: 1, frequency: 'months' } },
  { input: 'Taak *2w', recurrence: { interval: 2, frequency: 'weeks' } },
  { input: 'Taak *1d', recurrence: { interval: 1, frequency: 'days' } },
  { input: 'Taak *1j', recurrence: { interval: 1, frequency: 'years' } },
  { input: 'Taak *wekelijks', recurrence: { interval: 1, frequency: 'weeks' } },
];

export const HELP_QUICKBAR_FULL_EXAMPLE_INPUT =
  'Offerte nakijken #werk @kantoor ~30m >vrijdag';
